interface ColorIndicatorProps {
  color: string;
}

function ColorIndicator({ color }: ColorIndicatorProps) {
  return (
    <div className="mb-3">
      <div
        className="h-10 w-full rounded-md border border-border"
        style={{ backgroundColor: `rgb(${color})` }}
      />
    </div>
  );
}

export default ColorIndicator;
